import {ActionTree} from 'vuex';
import {WidgetState} from "@/apps/MyStudyChoiceActivitiesWidget/models/store-viewmodel";
import services from "@/apps/MyStudyChoiceHeartWidget/services";
export default <ActionTree<WidgetState, any>>{
    loadInitialData(context) {
        context.commit('setLoading', true)
        /**
         * retrieving activities only once, this is to prevent multiple calls on a page.
         */
        if (context.state.activities_retrieved) {
            return;
        }

        context.commit('activitiesRetrieved', true)

        services.myStudyChoice.getActivity(context.state.config.language)
            .then((response) => {
                context.commit('setActivities', response.data)
            })
            .catch(() => {
                context.commit('root/setErrors', ['Something went wrong retrieving your studychoice activities'])
            })
            .finally(() => {
                context.commit('setLoading', false)
            })
    },
    setConfig(context, payload) {
        context.commit('setConfig', payload)
    }
}
